export const faqs = [
  {
    q: "How long does the visa process take?",
    a: "Processing times vary by country and visa type. eVisas are typically approved within 24–72 hours. Sticker visas for embassies like the US, UK, or Schengen may take 5–15 business days. We always show the expected timeline before you apply.",
    tag: "Processing",
  },
  {
    q: "What documents do I need to submit?",
    a: "At minimum, you'll need a scanned copy of your passport (valid for at least 6 months), a recent passport-size photo, and basic travel details. Some countries require bank statements, hotel bookings, or travel insurance. Our smart checklist tells you exactly what's needed for your destination.",
    tag: "Documents",
  },
  {
    q: "Is my payment and personal data secure?",
    a: "Absolutely. We use 256-bit SSL encryption for all transactions. Your documents are stored on encrypted servers, shared only with the relevant embassy or immigration authority, and deleted after processing. We never sell your data.",
    tag: "Security",
  },
  {
    q: "What happens if my visa is rejected?",
    a: "In the rare event of a rejection, our team will analyse the reason and advise on reapplication options. If the rejection is due to an error on our end, we offer a full refund. Government visa fees are non-refundable by policy, but our service fee is.",
    tag: "Refunds",
  },
  {
    q: "Can I apply for multiple visas at once?",
    a: "Yes! You can manage multiple applications from a single dashboard — ideal for multi-country itineraries or family travel. Each application is tracked separately with real-time status updates.",
    tag: "Applications",
  },
  {
    q: "Do you offer emergency or express processing?",
    a: "Yes. We offer express processing for most eVisa destinations, with approvals possible in as little as 4–6 hours. Select 'Express' during checkout. An additional fee applies for expedited handling.",
    tag: "Processing",
  },
  {
    q: "How will I receive my approved visa?",
    a: "eVisas and eTAs are delivered directly to your registered email as a PDF, ready to print or show digitally at the airport. For sticker visas, we coordinate with the relevant embassy — your passport is collected and returned via courier.",
    tag: "Delivery",
  },
  {
    q: "Can I get a refund if I cancel my trip?",
    a: "Our service fee is refundable if your application hasn't been submitted to the embassy yet. Once submitted, government processing fees are non-refundable. Please check our full refund policy for details.",
    tag: "Refunds",
  },
];

